// src/App.tsx
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";

import AppLayout from "./components/layout/AppLayout";
import CrashProbe from "./components/_core/CrashProbe";
import RequireAdminAuth from "./components/auth/RequireAdminAuth";
import RequireAdminRole from "./components/auth/RequireAdminRole";
import { AdminAuthProvider } from "./auth/AdminAuthContext";

import Dashboard from "./pages/Dashboard/Dashboard";
import ProductsList from "./pages/Products/List";
import ProductCreate from "./pages/Products/Create";
import ProductEdit from "./pages/Products/Edit";
import OrdersListPage from "./pages/orders/OrdersListPage";
import OrderDetailPage from "./pages/orders/OrderDetailPage";
import SupportInbox from "./pages/SupportInbox";
import ContentManagementPage, {
  OperationsSettingsPage,
} from "./pages/Content/ContentManagementPage";
import AdminLoginPage from "./pages/Auth/AdminLoginPage";
import AcceptInvitePage from "./pages/Auth/AcceptInvitePage";
import AdminUsersPage from "./pages/AdminUsers/AdminUsersPage";
import ReviewCodesPage from "./pages/reviews/ReviewCodesPage";
import ReviewsModerationPage from "./pages/reviews/ReviewsModerationPage";
import SeoDashboardPage from "./pages/SEO/SeoDashboardPage";
import PromotionsPage from "./pages/Promotions/PromotionsPage";
import EmailLeadsPage from "./pages/EmailLeads/EmailLeadsPage";
import ActiveCustomerCartsPage from "./pages/Customers/ActiveCustomerCartsPage";
import AdminDocumentationPage from "./pages/AdminDocumentation/AdminDocumentationPage";
import WebsiteVisitsPage from "./pages/WebsiteVisitsPage";

function ProtectedShell() {
  return (
    <RequireAdminAuth>
      <AppLayout>
        <Outlet />
      </AppLayout>
    </RequireAdminAuth>
  );
}

export default function App() {
  return (
    <AdminAuthProvider>
      <Router>
        <CrashProbe />
        <Routes>
          <Route path="/login" element={<AdminLoginPage />} />
          <Route path="/accept-invite" element={<AcceptInvitePage />} />

          <Route path="/" element={<ProtectedShell />}>
            <Route index element={<Dashboard />} />
            <Route path="documentation" element={<AdminDocumentationPage />} />

            <Route path="products" element={<ProductsList />} />
            <Route path="products/new" element={<ProductCreate />} />
            <Route path="products/:id" element={<ProductEdit />} />

            <Route path="orders" element={<OrdersListPage />} />
            <Route path="orders/:idOrNumber" element={<OrderDetailPage />} />
            <Route path="reviews" element={<ReviewsModerationPage />} />
            <Route path="reviews/codes" element={<ReviewCodesPage />} />
            <Route path="promotions" element={<PromotionsPage />} />
            <Route
              path="email-leads"
              element={<Navigate to="/customers/email-leads" replace />}
            />
            <Route
              path="customers/carts"
              element={
                <RequireAdminRole roles={["super_admin", "manager"]}>
                  <ActiveCustomerCartsPage />
                </RequireAdminRole>
              }
            />
            <Route
              path="customers/email-leads"
              element={
                <RequireAdminRole roles={["super_admin", "manager"]}>
                  <EmailLeadsPage />
                </RequireAdminRole>
              }
            />

            <Route path="support" element={<SupportInbox />} />
            <Route
              path="website-visits"
              element={
                <RequireAdminRole roles={["super_admin", "manager"]}>
                  <WebsiteVisitsPage />
                </RequireAdminRole>
              }
            />
            <Route
              path="content"
              element={
                <RequireAdminRole roles={["super_admin"]}>
                  <ContentManagementPage />
                </RequireAdminRole>
              }
            />
            <Route
              path="settings/operations"
              element={
                <RequireAdminRole roles={["super_admin"]}>
                  <OperationsSettingsPage />
                </RequireAdminRole>
              }
            />
            <Route
              path="admin-users"
              element={
                <RequireAdminRole roles={["super_admin"]}>
                  <AdminUsersPage />
                </RequireAdminRole>
              }
            />
            <Route
              path="seo"
              element={
                <RequireAdminRole roles={["super_admin"]}>
                  <SeoDashboardPage />
                </RequireAdminRole>
              }
            />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AdminAuthProvider>
  );
}
